import Marquee from "react-fast-marquee";
import { useState } from "react";
import { Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "@/lib/motion";
import { AI_TOOLS } from "@/data/site";

const ToolLogo = ({ domain }) => {
  const [err, setErr] = useState(false);
  if (err) {
    return (
      <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand/15 text-brand-light">
        <Sparkles className="h-4 w-4" />
      </span>
    );
  }
  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${domain}&sz=128`}
      alt=""
      className="h-7 w-7 rounded-md bg-white/90 p-0.5 object-contain"
      loading="lazy"
      onError={() => setErr(true)}
    />
  );
};

export const ToolsMarquee = () => (
  <section className="relative py-16 md:py-20 overflow-hidden" data-testid="tools-marquee">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 text-center">
      <Reveal><Eyebrow className="justify-center">Master Latest AI Tools</Eyebrow></Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 font-heading text-3xl md:text-4xl font-semibold text-white tracking-tight">Learn the tools shaping the future</h2>
      </Reveal>
    </div>
    <div className="mt-10">
      <Marquee gradient gradientColor="#0F0F13" gradientWidth={140} speed={45} direction="right" autoFill pauseOnHover>
        {AI_TOOLS.map((t) => (
          <div key={t.name} className="mx-3 flex items-center gap-2.5 rounded-2xl border border-white/10 bg-ink-surface px-6 py-4 hover:border-brand/40 transition-colors">
            <ToolLogo domain={t.domain} />
            <span className="font-heading text-lg font-medium text-white whitespace-nowrap">{t.name}</span>
          </div>
        ))}
      </Marquee>
    </div>
  </section>
);
